import React, { useEffect, useState } from "react"; 
import { Formik, Form } from "formik";
import * as Yup from "yup";
import InputFields from "../../utils/UserInput";
import { Modal, message } from "antd";
import { postRequest } from "../../utils/APICall";
import { useDispatch, useSelector } from "react-redux";
import { updateDesignation } from "../../redux/designationSlice";
import moment from "moment";
import { XMarkIcon } from "@heroicons/react/16/solid";

const UpdateDesignationForm = ({ visible, onClose, singleData }) => {
  const dispatch = useDispatch()   
  const { users } = useSelector((state) => state.user || {})
  const [formData, setFormData] = useState({
    vdestitle: "",
  });

  useEffect(() => {
    if (singleData?.TITLE) {
      setFormData({
        vdestitle: singleData.TITLE,
      });
    }
  }, [singleData]);

  const validationSchema = Yup.object().shape({
    vdestitle: Yup.string().required("Title is required"),
  });

  const handleSubmit = async (values, { resetForm }) => {
    try {
      const payload = {
        vdesignationid: singleData?.CODE || 0,
        vdestitle: values.vdestitle,
        vcreatedby: `${users?.FIRSTNAME} ${users?.LASTNAME}| ${moment(Date.now()).format("DD-MM-YYYY HH:mm")}`,
      };

      const response = await postRequest("addDesignation", payload);

      if (response.success) {
        const updatedData = {
          CODE: payload.vdesignationid,
          TITLE: payload.vdestitle,
        }
        dispatch(updateDesignation(updatedData))
        message.success("Designation updated successfully!");
        resetForm();
        onClose();
      } else {
        message.error("Failed to update designation");
      }
    } catch (error) {
      message.error("An error occurred during update.");
    }
  };

  const showConfirm = (values, formikBag) => {
    Modal.confirm({
      title: 'Confirm Update',
      content: 'Are you sure you want to update this designation?',
      okText: 'Yes',
      cancelText: 'No',
      onOk: () => handleSubmit(values, formikBag),
    });
  };

  return (
    <Modal
      title={
        <div className="text-xl font-bold text-center pb-3 dark:bg-gray-900 dark:text-gray-100">
          Update Designation
        </div>
      }
      open={visible}
      onCancel={onClose}
      footer={null}
       className="dark:[&_.ant-modal-content]:bg-gray-900"
        closeIcon={
        <XMarkIcon
          className={"h-5 w-5  dark:text-white text-black"}
        />
      }
    >
      <Formik
        initialValues={formData}
        validationSchema={validationSchema}
        onSubmit={(values, formikBag) => showConfirm(values, formikBag)}
        enableReinitialize
      >
        {({ isValid, dirty }) => (
          <Form>
            <div className="grid gap-4 dark:bg-gray-900 dark:text-gray-100">
              <InputFields
                label="Title"
                type="text"
                placeholder="Designation Title"
                name="vdestitle"
              />
              <button
                type="submit"
                className="bg-blue-500 text-white py-2 px-4 rounded w-full"
                disabled={!(isValid && dirty)}
              >
                Update
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default UpdateDesignationForm;